module.exports = __webpack_public_path__ + "img/jia.fd88d2bb.jpg";